// Sensor image constants
export const SENSOR_IMAGES = {
  DEFAULT: '/assets/images/sensors/clipart/Default_Sensor.png',
  FORMALDEHYDE: '/assets/images/sensors/clipart/Formaldehyde_Sensor.png',
  PARTICLE_COUNT: '/assets/images/sensors/clipart/Particle_Count_Sensor.png',
  VOC: '/assets/images/sensors/clipart/VOC_Sensor.png',
  CO2: '/assets/images/sensors/clipart/CO2_Sensor.png',
  TEMPERATURE: '/assets/images/sensors/clipart/Default_Sensor.png',
  HUMIDITY: '/assets/images/sensors/clipart/Default_Sensor.png',
  PRESSURE: '/assets/images/sensors/clipart/Pressure_Sensor.png',
  PARTICLES: '/assets/images/sensors/clipart/Particle_Count_Sensor.png',
  CO: '/assets/images/sensors/clipart/Default_Sensor.png',
  MERCAPTAN: '/assets/images/sensors/clipart/Default_Sensor.png',
  NOX: '/assets/images/sensors/clipart/Default_Sensor.png'
};

// Sensor configuration lookup table
export const SENSOR_CONFIG = {
  // VOC sensors
  'tvoc_data': { name: 'VOC', image: SENSOR_IMAGES.VOC },
  'tvoc(ppm)': { name: 'VOC', image: SENSOR_IMAGES.VOC },
  'voc': { name: 'VOC', image: SENSOR_IMAGES.VOC },
  'voc_data': { name: 'VOC', image: SENSOR_IMAGES.VOC },
  
  // CO2 sensors
  'co2_data': { name: 'CO2', image: SENSOR_IMAGES.CO2 },
  'co2(ppm)': { name: 'CO2', image: SENSOR_IMAGES.CO2 },
  'co2': { name: 'CO2', image: SENSOR_IMAGES.CO2 },

  // Multi-gas channels (VPSIAIRPLUS)
  'co': { name: 'Carbon Monoxide', image: SENSOR_IMAGES.CO },
  'mercaptan': { name: 'Mercaptan', image: SENSOR_IMAGES.MERCAPTAN },
  'nox': { name: 'NOx Index', image: SENSOR_IMAGES.NOX },

  // Temperature sensors (Celsius)
  'temperature_data': { name: 'Temperature (C)', image: SENSOR_IMAGES.TEMPERATURE },
  'temp': { name: 'Temperature (C)', image: SENSOR_IMAGES.TEMPERATURE },
  
  // Temperature sensors (Fahrenheit)
  'temperature_data_f': { name: 'Temperature (F)', image: SENSOR_IMAGES.TEMPERATURE },
  'temp_f': { name: 'Temperature (F)', image: SENSOR_IMAGES.TEMPERATURE },
  
  // Humidity sensors
  'humidity_data': { name: 'Humidity (%)', image: SENSOR_IMAGES.HUMIDITY },
  'hum': { name: 'Humidity (%)', image: SENSOR_IMAGES.HUMIDITY },
  
  // Pressure sensors
  'pressure_data': { name: 'Pressure (Pa)', image: SENSOR_IMAGES.PRESSURE },
  
  // Particle sensors
  '0.3_per_100_cm^3_data': { name: '0.3um Particles', image: SENSOR_IMAGES.PARTICLES },
  'num_particles_0.3': { name: '0.3um Particles', image: SENSOR_IMAGES.PARTICLES },
  'sp pm0.3': { name: '0.3um Particles', image: SENSOR_IMAGES.PARTICLES },
  
  '0.5_per_100_cm^3_data': { name: '0.5um Particles', image: SENSOR_IMAGES.PARTICLES },
  'num_particles_0.5': { name: '0.5um Particles', image: SENSOR_IMAGES.PARTICLES },
  'sp pm0.5': { name: '0.5um Particles', image: SENSOR_IMAGES.PARTICLES },
  '0.5um particles': { name: '0.5um Particles', image: SENSOR_IMAGES.PARTICLES },
  
  '1.0_per_100_cm^3_data': { name: '1um Particles', image: SENSOR_IMAGES.PARTICLES },
  'num_particles_1.0': { name: '1um Particles', image: SENSOR_IMAGES.PARTICLES },
  '1.0um particles': { name: '1um Particles', image: SENSOR_IMAGES.PARTICLES },
  
  '2.5_per_100_cm^3_data': { name: '2.5um Particles', image: SENSOR_IMAGES.PARTICLES },
  'num_particles_2.5': { name: '2.5um Particles', image: SENSOR_IMAGES.PARTICLES },
  '2.5um particles': { name: '2.5um Particles', image: SENSOR_IMAGES.PARTICLES },
  
  '5.0_per_100_cm^3_data': { name: '5um Particles', image: SENSOR_IMAGES.PARTICLES },
  'num_particles_5.0': { name: '5um Particles', image: SENSOR_IMAGES.PARTICLES },
  '5.0um particles': { name: '5um Particles', image: SENSOR_IMAGES.PARTICLES },
  
  '10.0_per_100_cm^3_data': { name: '10um Particles', image: SENSOR_IMAGES.PARTICLES },
  'num_particles_10.0': { name: '10um Particles', image: SENSOR_IMAGES.PARTICLES },
  '10.0um particles': { name: '10um Particles', image: SENSOR_IMAGES.PARTICLES },
  
  // PM Particulates
  'pm1.0_ultra_fine_particulates_data': { name: 'PM1.0 Particulates', image: SENSOR_IMAGES.PARTICLES },
  'pm1.0(ae ppm)': { name: 'PM1.0 Particulates', image: SENSOR_IMAGES.PARTICLES },
  'ae pm1.0': { name: 'PM1.0 Particulates', image: SENSOR_IMAGES.PARTICLES },
  'pm1': { name: 'PM1.0 Particulates', image: SENSOR_IMAGES.PARTICLES },
  
  'pm2.5_fine_particles_data': { name: 'PM2.5 Particulates', image: SENSOR_IMAGES.PARTICLES },
  'pm2.5(ae ppm)': { name: 'PM2.5 Particulates', image: SENSOR_IMAGES.PARTICLES },
  'ae pm2.5': { name: 'PM2.5 Particulates', image: SENSOR_IMAGES.PARTICLES },
  'pm2.5': { name: 'PM2.5 Particulates', image: SENSOR_IMAGES.PARTICLES },
  
  'pm10.0_data': { name: 'PM10.0 Particulates', image: SENSOR_IMAGES.PARTICLES },
  'pm10.0(ae ppm)': { name: 'PM10.0 Particulates', image: SENSOR_IMAGES.PARTICLES },
  'ae pm10.0': { name: 'PM10.0 Particulates', image: SENSOR_IMAGES.PARTICLES },
  'ae pm10': { name: 'PM10.0 Particulates', image: SENSOR_IMAGES.PARTICLES },
  'pm10': { name: 'PM10.0 Particulates', image: SENSOR_IMAGES.PARTICLES },
  
  // Formaldehyde sensors
  'hcho(mg/m3)': { name: 'Formaldehyde (Mg/m3)', image: SENSOR_IMAGES.FORMALDEHYDE },
  'hcho_data': { name: 'Formaldehyde', image: SENSOR_IMAGES.FORMALDEHYDE },
  
  // Device sensors
  'device battery': { name: 'Device Battery', image: SENSOR_IMAGES.DEFAULT },
  'device sensor id': { name: 'Device Sensor ID', image: SENSOR_IMAGES.DEFAULT },
  
  // Other sensors
  'particle count': { name: 'Particle Count', image: SENSOR_IMAGES.PARTICLE_COUNT },
  'random': { name: 'RNG', image: SENSOR_IMAGES.DEFAULT }
};

// Group sensor types by their display name for matchingIds
export const SENSOR_GROUPS = {
  'VOC': ['tvoc_data', 'tvoc(ppm)', 'voc', 'voc_data'],
  'CO2': ['co2_data', 'co2(ppm)', 'co2'],
  'Carbon Monoxide': ['co'],
  'Mercaptan': ['mercaptan'],
  'NOx Index': ['nox'],
  'Temperature (C)': ['temperature_data', 'temp'],
  'Temperature (F)': ['temperature_data_f', 'temp_f'],
  'Humidity (%)': ['humidity_data', 'hum'],
  'Pressure (Pa)': ['pressure_data'],
  '0.3um Particles': ['0.3_per_100_cm^3_data', 'num_particles_0.3', 'sp pm0.3'],
  '0.5um Particles': ['0.5_per_100_cm^3_data', 'num_particles_0.5', 'sp pm0.5', '0.5um particles'],
  '1um Particles': ['1.0_per_100_cm^3_data', 'num_particles_1.0', '1.0um particles'],
  '2.5um Particles': ['2.5_per_100_cm^3_data', 'num_particles_2.5', '2.5um particles'],
  '5um Particles': ['5.0_per_100_cm^3_data', 'num_particles_5.0', '5.0um particles'],
  '10um Particles': ['10.0_per_100_cm^3_data', 'num_particles_10.0', '10.0um particles'],
  'PM1.0 Particulates': ['pm1.0_ultra_fine_particulates_data', 'pm1.0(ae ppm)', 'ae pm1.0', 'pm1'],
  'PM2.5 Particulates': ['pm2.5_fine_particles_data', 'pm2.5(ae ppm)', 'ae pm2.5', 'pm2.5'],
  'PM10.0 Particulates': ['pm10.0_data', 'pm10.0(ae ppm)', 'ae pm10.0', 'ae pm10', 'pm10'],
  'Formaldehyde (Mg/m3)': ['hcho(mg/m3)'],
  'Formaldehyde': ['hcho_data'],
  'Device Battery': ['device battery'],
  'Device Sensor ID': ['device sensor id'],
  'Particle Count': ['particle count'],
  'RNG': ['random']
}; 